import React, { useCallback } from "react";
import { useSelector } from "react-redux";
import { includes, mapValues, pickBy } from "lodash";
import { selectNetworkId } from "selectors/environment";
import MembershipForm from "./MembershipForm";
import { fetchApi } from "../../helpers/reactQueryApi";

const changeRequestsProfileFields =
  window.Preload.current_network.config.memberships?.change_requests
    ?.profile_fields;

export default function NewChangeRequest() {
  const membershipId = window.Preload.current_member.id;
  const networkId = useSelector(selectNetworkId);
  const externalAppId = `profile:${networkId}`;
  const externalItemId = membershipId;
  const filterProperties = useCallback(
    ({ name }) => includes(changeRequestsProfileFields, name),
    [],
  );
  const mapProperties = useCallback(
    (prop) => ({ ...prop, can: { update: true } }),
    [],
  );
  const transformItem = useCallback(
    (item) => ({ ...item, can: mapValues(item.can, () => true) }),
    [],
  );

  const onSubmit = async (values) => {
    const body = pickBy(values, (value, name) => filterProperties({ name }));
    return fetchApi(`/change_requests`, {
      method: "POST",
      body,
    });
  };

  const onSubmitSuccess = () => {
    location.replace(`/members/${membershipId}`);
    toastr.success(I18n.t("js.saving_successful"));
  };

  return (
    <MembershipForm
      externalAppId={externalAppId}
      externalItemId={externalItemId}
      onSubmit={onSubmit}
      onSubmitSuccess={onSubmitSuccess}
      title={I18n.t("js.memberships.change_requests.title")}
      filterProperties={filterProperties}
      mapProperties={mapProperties}
      transformItem={transformItem}
    />
  );
}
